import type { ICustomerApi } from "../../application/interfaces/ICustomerApi";
import type { IAccessTokenProvider } from "../../application/interfaces/IAccessTokenProvider";
import type { IAppConfigProvider } from "../../application/interfaces/IAppConfigProvider";
import type { CustomerMeDto } from "../../shared/CustomerMeDto";

export class CustomerApi implements ICustomerApi {
  readonly configProvider: IAppConfigProvider;
  readonly tokenProvider: IAccessTokenProvider;

  constructor(configProvider: IAppConfigProvider, tokenProvider: IAccessTokenProvider) {
    this.configProvider = configProvider;
    this.tokenProvider = tokenProvider;
  }

  async me(): Promise<CustomerMeDto | null> {
    const token = await this.tokenProvider.getAccessToken();
    if (!token) {
      return null;
    }
    const config = await this.configProvider.getAppConfig();
    const response = await fetch(`${config.apiUrl}/Customer/Me`, {
      headers: {
        "X-Api-Key": config.apiKey,
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    if (response.status == 401) {
      return null;
    }
    if (!response.ok) {
      throw new Error(`Kundendaten konnten nicht geladen werden (HTTP ${response.status})`);
    }
    return (await response.json()) as CustomerMeDto;
  }
}
